import { render } from "./ShorttermPlotsContent.vue?vue&type=template&id=06252b06"
import script from "./ShorttermPlotsContent.vue?vue&type=script&lang=js"
export * from "./ShorttermPlotsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__